module.exports = __webpack_public_path__ + "static/img/img_6.095136d5.jpg";